import React from 'react';
export function Skeleton({
  className = ''
}) {
  return <div className={`animate-pulse bg-gray-200 rounded ${className}`} data-id="element-99"></div>;
}
export function SkeletonCard() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 mb-3" data-id="element-100">
      <div className="flex items-center" data-id="element-101">
        <Skeleton className="w-10 h-10 rounded-full mr-3" data-id="element-102" />
        <div className="flex-1" data-id="element-103">
          <Skeleton className="h-4 w-24 mb-2" data-id="element-104" />
          <Skeleton className="h-3 w-32" data-id="element-105" />
        </div>
        <div className="flex flex-col items-end" data-id="element-106">
          <Skeleton className="h-4 w-16 mb-2" data-id="element-107" />
          <Skeleton className="h-5 w-20 rounded-full" data-id="element-108" />
        </div>
      </div>
    </div>;
}